import store from "../../../../../store";
import { has } from "../../../../../utils/menu-context";

export const commonInputPropField = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses?.includes(initialModel.refStatus?.key) || disabledRequestTypes?.includes(modelRef.refRequestType?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) {
                return false;
            }
            if (has({ menuContext, key: "forRequest" })) {
                if (["draft", "reEditAuthority"].includes(record?.refStatus?.key)) {
                    result = true || result;
                }
            }
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitReceive", "waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" }) || record.isOfficerCreate) {
                if ([null, "draft", "reEditAuthority"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forApprove" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    if (record.refToApproveBy?.username === userInfo.username) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forRequest" })) {
                if (["waitApprove"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refRequestType",
                    "refSendSampling.refRelease.refInspection.refInformTemp.approveCode",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return ["requestCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.requestCode
            },
        },
        {
            check: ({ field }) => {
                return ["refSendSamplingTemp.approveCode"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.refSendSamplingTemp?.approveCode
            },
        },
        {
            check: ({ field }) => {
                return ["refSendSampling"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["4"].includes(modelRef.refRequestType?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forApproveRemark.0.remark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitResponseCustoms",
                    "reEditOfficer",
                    "reEditAuthority",
                    "reEditCustoms",
                    "waitPayment",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                const regExps = [
                    new RegExp(`^refSendSamplingTemp\\.products\\.[^\\.]+\\.(refTopic)$`, "g"),
                    new RegExp(`^refSendSamplingTemp\\.products\\.[^\\.]+\\.(refMethod)$`, "g"),
                ];
                return regExps.some(d => d.test(field?.key));
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitRelease",
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
    ];
};
